"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpDelete = exports.httpPut = exports.httpPost = exports.httpGet = void 0;
const baseClient_1 = require("./baseClient");
const Client = __importStar(require("./client"));
var baseClient_2 = require("./baseClient");
Object.defineProperty(exports, "httpGet", { enumerable: true, get: function () { return baseClient_2.httpGet; } });
Object.defineProperty(exports, "httpPost", { enumerable: true, get: function () { return baseClient_2.httpPost; } });
Object.defineProperty(exports, "httpPut", { enumerable: true, get: function () { return baseClient_2.httpPut; } });
Object.defineProperty(exports, "httpDelete", { enumerable: true, get: function () { return baseClient_2.httpDelete; } });
class WintApiClient {
    constructor(axiosInstance) {
        this.PersonSalaryClient = new Client.PersonSalaryClient("api/PersonSalary");
        this.SalaryDraftsClient = new Client.SalaryDraftsClient("api/SalaryDrafts");
        this.AccountClient = new Client.AccountClient("api/Account");
        this.AgentSaleClient = new Client.AgentSaleClient("api/AgentSale");
        this.AgingIncomingInvoiceClient = new Client.AgingIncomingInvoiceClient("api/AgingIncomingInvoice");
        this.AgreementClient = new Client.AgreementClient("api/Agreement");
        this.AnnualAccountsClient = new Client.AnnualAccountsClient("api/AnnualAccounts");
        this.ArticleClient = new Client.ArticleClient("api/Article");
        this.AuditClient = new Client.AuditClient("api/Audit");
        this.AuthClient = new Client.AuthClient("api/Auth");
        this.BankBalanceClient = new Client.BankBalanceClient("api/BankBalance");
        this.BankIdAuthClient = new Client.BankIdAuthClient("api/BankIdAuth");
        this.BankIdSignClient = new Client.BankIdSignClient("api/BankIdSign");
        this.BenefitClient = new Client.BenefitClient("api/Benefit");
        this.BusinessUnitsClient = new Client.BusinessUnitsClient("api/BusinessUnits");
        this.CashReconciliationClient = new Client.CashReconciliationClient("api/CashReconciliation");
        this.CommissionSalaryReportClient = new Client.CommissionSalaryReportClient("api/CommissionSalaryReport");
        this.CompactReportsClient = new Client.CompactReportsClient("api/CompactReports");
        this.CompanyAuthClient = new Client.CompanyAuthClient("api/CompanyAuth");
        this.CompanyClient = new Client.CompanyClient("api/Company");
        this.CostForwardingClient = new Client.CostForwardingClient("api/CostForwarding");
        this.CurrencyClient = new Client.CurrencyClient("api/Currency");
        this.CustomerClient = new Client.CustomerClient("api/Customer");
        this.CustomerFeedbackClient = new Client.CustomerFeedbackClient("api/CustomerFeedback");
        this.DeadlineClient = new Client.DeadlineClient("api/Deadline");
        this.DeclarationClient = new Client.DeclarationClient("api/Declaration");
        this.DiagnosticsClient = new Client.DiagnosticsClient("api/Diagnostics");
        this.DimensionClient = new Client.DimensionClient("api/Dimension");
        this.DimensionPresetClient = new Client.DimensionPresetClient("api/DimensionPreset");
        this.DimensionsReportClient = new Client.DimensionsReportClient("api/DimensionsReport");
        this.DimensionTypesClient = new Client.DimensionTypesClient("api/DimensionTypes");
        this.DocumentationLogClient = new Client.DocumentationLogClient("api/DocumentationLog");
        this.DocumentClient = new Client.DocumentClient("api/Document");
        this.DocumentDraftClient = new Client.DocumentDraftClient("api/DocumentDraft");
        this.EarlyPayoutClient = new Client.EarlyPayoutClient("api/EarlyPayout");
        this.EmployeesClient = new Client.EmployeesClient("api/Employees");
        this.ExportItemsClient = new Client.ExportItemsClient("api/ExportItems");
        this.FAQServiceClient = new Client.FAQServiceClient("api/FAQService");
        this.FeatureClient = new Client.FeatureClient("api/Feature");
        this.FileClient = new Client.FileClient("api/File");
        this.FilterClient = new Client.FilterClient("api/Filter");
        this.FinancialReportsClient = new Client.FinancialReportsClient("api/FinancialReports");
        this.GenericCommentClient = new Client.GenericCommentClient("api/GenericComment");
        this.GenericDocumentClient = new Client.GenericDocumentClient("api/GenericDocument");
        this.HoldingRegisterClient = new Client.HoldingRegisterClient("api/HoldingRegister");
        this.ImageClient = new Client.ImageClient("api/Image");
        this.IncomingInvoiceBookingTipClient = new Client.IncomingInvoiceBookingTipClient("api/IncomingInvoiceBookingTip");
        this.IncomingInvoiceClient = new Client.IncomingInvoiceClient("api/IncomingInvoice");
        this.InvoiceClient = new Client.InvoiceClient("api/Invoice");
        this.InvoicePaymentOptionClient = new Client.InvoicePaymentOptionClient("api/InvoicePaymentOption");
        this.LeadClient = new Client.LeadClient("api/Lead");
        this.LoggingClient = new Client.LoggingClient("api/Logging");
        this.MissingDocumentClient = new Client.MissingDocumentClient("api/MissingDocument");
        this.MonthlyReportsClient = new Client.MonthlyReportsClient("api/MonthlyReports");
        this.NewsArticlesClient = new Client.NewsArticlesClient("api/NewsArticles");
        this.NotificationClient = new Client.NotificationClient("api/Notification");
        this.OffboardingBankIdAuthClient = new Client.OffboardingBankIdAuthClient("api/bankidauth/offboarding");
        this.OnboardingBankIdAuthClient = new Client.OnboardingBankIdAuthClient("api/bankidauth/onboarding");
        this.OnboardingTestSessionClient = new Client.OnboardingTestSessionClient("api/onboarding/test-session");
        this.PaymentClient = new Client.PaymentClient("api/Payment");
        this.PingClient = new Client.PingClient("api/Ping");
        this.PreliminaryTaxUpdateClient = new Client.PreliminaryTaxUpdateClient("api/PreliminaryTaxUpdate");
        this.ProfileImagesClient = new Client.ProfileImagesClient("api/ProfileImages");
        this.ProfileRoutineClient = new Client.ProfileRoutineClient("api/ProfileRoutine");
        this.QualifiedShareDividendClient = new Client.QualifiedShareDividendClient("api/QualifiedShareDividend");
        this.QuotationClient = new Client.QuotationClient("api/Quotation");
        this.ReceiptCategoryClient = new Client.ReceiptCategoryClient("api/ReceiptCategory");
        this.ReceiptClient = new Client.ReceiptClient("api/Receipt");
        this.ReceiptPaymentMethodClient = new Client.ReceiptPaymentMethodClient("api/ReceiptPaymentMethod");
        this.ReceiptReportClient = new Client.ReceiptReportClient("api/ReceiptReport");
        this.RecurringInvoiceClient = new Client.RecurringInvoiceClient("api/RecurringInvoice");
        this.ReferenceClient = new Client.ReferenceClient("api/Reference");
        this.ReportClient = new Client.ReportClient("api/Report");
        this.ReportWidgetClient = new Client.ReportWidgetClient("api/ReportWidget");
        this.RevenueReportingClient = new Client.RevenueReportingClient("api/RevenueReporting");
        this.SalaryClient = new Client.SalaryClient("api/Salary");
        this.SalaryDeviationClient = new Client.SalaryDeviationClient("api/SalaryDeviation");
        this.SalaryImportClient = new Client.SalaryImportClient("api/SalaryImport");
        this.SalarySpecificationDocumentClient = new Client.SalarySpecificationDocumentClient("api/SalarySpecificationDocument");
        this.SearchClient = new Client.SearchClient("api/Search");
        this.SelfInvoiceClient = new Client.SelfInvoiceClient("api/SelfInvoice");
        this.SeriesClient = new Client.SeriesClient("api/Series");
        this.SettingsClient = new Client.SettingsClient("api/Settings");
        this.ShareRegisterClient = new Client.ShareRegisterClient("api/ShareRegister");
        this.SkattekontoClient = new Client.SkattekontoClient("api/Skattekonto");
        this.StoppedPaymentClient = new Client.StoppedPaymentClient("api/StoppedPayment");
        this.SupplementaryMaterialsClient = new Client.SupplementaryMaterialsClient("api/SupplementaryMaterials");
        this.SupportAgentClient = new Client.SupportAgentClient("api/SupportAgent");
        this.SupportCategoryClient = new Client.SupportCategoryClient("api/SupportCategory");
        this.SupportClient = new Client.SupportClient("api/Support");
        this.SupportTeamClient = new Client.SupportTeamClient("api/SupportTeam");
        this.SurveyClient = new Client.SurveyClient("api/Survey");
        this.TimeReportClient = new Client.TimeReportClient("api/TimeReport");
        this.TimeReportingProjectClient = new Client.TimeReportingProjectClient("api/TimeReportingProject");
        this.TodoClient = new Client.TodoClient("api/Todo");
        this.TransactionClient = new Client.TransactionClient("api/Transaction");
        this.UnitClient = new Client.UnitClient("api/Unit");
        this.UserApiKeyClient = new Client.UserApiKeyClient("api/auth");
        this.UserClient = new Client.UserClient("api/User");
        this.UtilsClient = new Client.UtilsClient("api/Utils");
        this.VatReportsClient = new Client.VatReportsClient("api/VatReports");
        this.VoucherClient = new Client.VoucherClient("api/Voucher");
        this.VoucherImagesClient = new Client.VoucherImagesClient("api/VoucherImages");
        this.WarmUpClient = new Client.WarmUpClient("api/WarmUp");
        this.WintCardClient = new Client.WintCardClient("api/WintCard");
        this.WintSalaryCommissionClient = new Client.WintSalaryCommissionClient("api/WintSalaryCommission");
        this.WintSalaryClient = new Client.WintSalaryClient("api/WintSalary");
        this.WintSalaryDeviationClient = new Client.WintSalaryDeviationClient("api/WintSalaryDeviation");
        this.AutomationRuleClient = new Client.AutomationRuleClient("api/AutomationRule");
        this.ReceiptAutomationRuleClient = new Client.ReceiptAutomationRuleClient("api/ReceiptAutomationRule");
        (0, baseClient_1.create)(axiosInstance);
    }
}
exports.default = WintApiClient;
